import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isHome = location.pathname === '/';

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-14 md:h-16">
          <Link
            to="/"
            className="flex items-center gap-2 cursor-pointer"
            onClick={() => setMobileMenuOpen(false)}
          >
            <span className="font-heading text-lg md:text-xl font-semibold text-foreground-900">
              Yoybuy Sheet
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer ${
                isHome
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              <i className="ri-home-line w-4 h-4 inline-flex items-center justify-center mr-1.5"></i>
              Главная
            </Link>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium text-foreground-600 hover:text-foreground-900 hover:bg-background-100 transition-all duration-200 cursor-pointer"
            >
              <i className="ri-shopping-bag-line w-4 h-4 inline-flex items-center justify-center mr-1.5"></i>
              Гид по покупкам
            </a>

            <Link
              to="/article/yoybuy-spreadsheet-guide"
              className="whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium text-foreground-600 hover:text-foreground-900 hover:bg-background-100 transition-all duration-200 cursor-pointer"
            >
              <i className="ri-book-open-line w-4 h-4 inline-flex items-center justify-center mr-1.5"></i>
              Руководство
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-2">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap px-5 py-2 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold rounded-full transition-all duration-200 cursor-pointer"
            >
              {t('btn_yoybuy_sheet')}
            </a>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="Меню"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} w-6 h-6 flex items-center justify-center`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden border-t border-background-200 py-4 space-y-2">
            <Link
              to="/"
              onClick={() => setMobileMenuOpen(false)}
              className={`block w-full px-4 py-3 rounded-xl text-sm font-medium transition-colors cursor-pointer ${
                isHome
                  ? 'bg-primary-50 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <i className="ri-home-line w-5 h-5 inline-flex items-center justify-center mr-2"></i>
              Главная
            </Link>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setMobileMenuOpen(false)}
              className="block w-full px-4 py-3 rounded-xl text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className="ri-shopping-bag-line w-5 h-5 inline-flex items-center justify-center mr-2"></i>
              Гид по покупкам
            </a>

            <Link
              to="/article/yoybuy-spreadsheet-guide"
              onClick={() => setMobileMenuOpen(false)}
              className="block w-full px-4 py-3 rounded-xl text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className="ri-book-open-line w-5 h-5 inline-flex items-center justify-center mr-2"></i>
              Руководство
            </Link>

            <div className="pt-2 px-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setMobileMenuOpen(false)}
                className="block w-full text-center px-5 py-3 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold rounded-full transition-all cursor-pointer"
              >
                {t('btn_yoybuy_sheet')}
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}